import { defineComponent } from 'vue';
import useI18nMessages from '../../../common/composables/useI18nMessages';
import {
  ZidBox,
  ZidHeading,
  ZidLoader,
  ZidSelect,
  ZidSelectBody,
  ZidSelectHeader,
  ZidSelectOption,
  ZidText,
  ZidButton,
} from '@zidsa/ui';
import { HermesOtlStoreModule } from './../../../account/store/hermes-otl.module';
import AppStoreReadyStateEnum from '../../store/ready-state.enum';
import isProduction from './../../../common/helpers/is-production';
import isRTL from '../../../common/helpers/is-lang-arabic';
import ApiModelFeatureFlagsInterface from '../../../api/model/feature-flags.interface';
import { AccountSettingsStoreModule } from '../../../settings/store/account-settings/module';

export default defineComponent({
  name: 'HermesToggle',
  components: {
    ZidBox,
    ZidHeading,
    ZidSelect,
    ZidSelectHeader,
    ZidSelectBody,
    ZidSelectOption,
    ZidText,
    ZidLoader,
    ZidButton,
  },
  props: {},
  data() {
    return {
      label: '',
      isShown: true,
    };
  },
  computed: {
    isLoading() {
      return HermesOtlStoreModule.loadingState == AppStoreReadyStateEnum.loading;
    },
    featureFlagInfo(): ApiModelFeatureFlagsInterface | null {
      return AccountSettingsStoreModule.featureFlags;
    },
  },
  methods: {
    navigateToHermes() {
      HermesOtlStoreModule.getHermesOtl().then((r) => {
        const token = r.token;
        const lang = isRTL() ? 'ar-sa' : 'en-sa';
        if (isProduction()) window.location.href = 'https://dashboard.zid.sa/' + lang + '/login/otl/' + token;
        else window.location.href = 'https://hermes.zid.dev/' + lang + '/login/otl/' + token;
      });
    },
  },
  mounted() {
    AccountSettingsStoreModule.getFeatureFlagInfo();
  },
  setup() {
    const I18nMessages = useI18nMessages();

    return { I18nMessages };
  },
});
